import { FC, HTMLAttributes } from "react";
import { CSSProperties } from "styled-components";
import { StyledFrame } from "./IFrame.styles";

interface IframeHTMLAttributes<T> extends HTMLAttributes<T> {
  allow?: string;
  allowFullScreen?: boolean;
  allowTransparency?: boolean;
  frameBorder?: number | string;
  marginHeight?: number;
  marginWidth?: number;
  name?: string;
  sandbox?: string;
  scrolling?: string;
  seamless?: boolean;
  src?: T;
  srcDoc?: string;
  height?: number | string;
  width?: number | string;
  style?: CSSProperties;
  text?: string;
}

const IFrame: FC<IframeHTMLAttributes<string>> = ({
  height,
  width,
  text,
  src,
  allowFullScreen = true,
  sandbox = "",
  style,
}) => {
  return (
    <StyledFrame>
      <iframe
        style={style}
        height={height}
        width={width}
        src={src}
        allowFullScreen={allowFullScreen}
        sandbox={sandbox}
        allow='*'
      >
        {text}
      </iframe>
    </StyledFrame>
  );
};

export default IFrame;
